(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozy-footer"]) return;
  try {
    
if(!customElements.get('cozy-footer-controls'))customElements.define('cozy-footer-controls',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelectorAll('.sc-localization select').forEach(select=>select.addEventListener('change',()=>{const form=select.form;form.setAttribute('aria-busy','true');form.requestSubmit();}));this.querySelector('[data-cookie-settings]').addEventListener('click',()=>{const error=this.querySelector('[data-cookie-error]');if(window.privacyBanner?.showPreferences){error.hidden=true;window.privacyBanner.showPreferences();}else{error.hidden=false;}});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-offer"]) return;
  try {
    
if(!customElements.get('cozy-love-offer'))customElements.define('cozy-love-offer',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.abort=new AbortController();const opts={signal:this.abort.signal};this.key='squishycubs-love10-dismissed';document.addEventListener('click',e=>{const open=e.target.closest('[data-open-love]');if(open){e.preventDefault();this.open(open);return;}},opts);this.querySelectorAll('[data-love-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close(),opts));this.dialog.addEventListener('close',()=>{this.remember();this.opener?.focus({preventScroll:true});},opts);this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const b=this.dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.dialog.close();},opts);this.querySelector('[data-love-apply]').addEventListener('click',()=>this.remember(),opts);this.querySelector('[data-love-copy]').addEventListener('click',async e=>{const button=e.currentTarget;try{await navigator.clipboard.writeText('LOVE10');button.textContent=button.dataset.success;this.querySelector('[data-copy-status]').textContent=button.dataset.success;}catch{const range=document.createRange();range.selectNodeContents(this.querySelector('.sc-love-code strong'));const selection=getSelection();selection.removeAllRanges();selection.addRange(range);}},opts);if(this.dataset.auto==='true'&&!this.dismissed())this.timer=setTimeout(()=>this.maybeOpen(),Number(this.dataset.delay)||12000);}
dismissed(){try{return sessionStorage.getItem(this.key)==='yes';}catch{return false;}}
remember(){try{sessionStorage.setItem(this.key,'yes');}catch{}}
maybeOpen(){if(this.dismissed())return;const banner=document.querySelector('#shopify-pc__banner');const blocked=banner&&banner.getClientRects().length>0&&getComputedStyle(banner).visibility!=='hidden';if(blocked||document.hidden||document.querySelector('dialog[open]')){this.timer=setTimeout(()=>this.maybeOpen(),1500);return;}this.open();}
open(opener){this.opener=opener||document.activeElement;if(!this.dialog.open)this.dialog.showModal();}
disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cozy-product')) {
  customElements.define('cozy-product', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.data = JSON.parse(this.querySelector('[data-cozy-data]').textContent);
      this.preview = this.dataset.preview === 'true';
      this.form = this.querySelector('.cozy-form');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.mainImage = this.querySelector('[data-main-image]');
      this.sticky = this.querySelector('[data-sticky]');
      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-variant]')) this.select(event.target.value, true);
        if (event.target === this.quantity) this.syncQuantity();
      }, options);
      this.form.addEventListener('submit', (event) => this.add(event), options);
      this.addEventListener('click', (event) => {
        const optionLabel = event.target.closest('.cozy-option label');
        if (optionLabel?.control) this.select(optionLabel.control.value, true);
        const photo = event.target.closest('[data-photo]');
        if (photo) this.showPhoto(photo.dataset.src, photo.dataset.alt, photo.dataset.imageId);
        const pick = event.target.closest('[data-select]');
        if (pick) {
          this.select(pick.dataset.select, true);
          this.querySelector('.cozy-picker').scrollIntoView({block:'center', behavior:this.motion()});
          this.querySelector('[data-variant]:checked').focus({preventScroll:true});
        }
        const quantity = event.target.closest('[data-quantity]');
        if (quantity) { this.quantity.value = Number(this.quantity.value || 1) + Number(quantity.dataset.quantity); this.syncQuantity(); }
        if (event.target.closest('[data-zoom]')) {
          const image = this.querySelector('[data-zoom-image]');
          image.src = this.mainImage.src; image.alt = this.mainImage.alt;
          this.openDialog(this.querySelector('[data-lightbox]'), event.target.closest('button'));
        }
        const close = event.target.closest('[data-close]');
        if (close) close.closest('dialog').close();
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => this.opener?.focus({preventScroll:true}), options);
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } }, options);
      });
      this.observer = new IntersectionObserver(([entry]) => { this.sticky.hidden = entry.isIntersecting && entry.intersectionRatio > 0.85; },{threshold:[0,0.85,1]});
      this.observer.observe(this.querySelector('[data-buy-anchor]'));
      this.select(this.form.querySelector('[data-variant]:checked').value, false);
      this.syncQuantity();
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
    select(id, updatePhoto) {
      const variant = this.data.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.variant = variant;
      this.form.querySelectorAll('[data-variant]').forEach(input => input.checked = input.value === String(id));
      this.querySelectorAll('[data-selected-name]').forEach(element => element.textContent = variant.name);
      this.querySelectorAll('[data-price]').forEach(element => element.textContent = variant.price);
      this.querySelector('[data-personality]').textContent = variant.personality;
      this.querySelector('[data-sticky-image]').src = variant.image;
      this.querySelector('[data-preview-image]').src = variant.image;
      this.querySelectorAll('[data-add]').forEach(button => button.disabled = !variant.available && !this.preview);
      this.querySelector('[data-cta-text]').textContent = variant.available || this.preview ? this.data.add.replace('__NAME__', variant.name) : this.data.soldOut;
      if (updatePhoto) {
        this.showPhoto(variant.image, variant.alt, variant.imageId);
        const url = new URL(location.href); url.searchParams.set('variant', String(id)); history.replaceState({}, '', url);
      }
    }
    showPhoto(src, alt, imageId) {
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = src; this.mainImage.alt = alt || '';
      this.querySelectorAll('[data-photo]').forEach(button => {
        const selected = String(button.dataset.imageId) === String(imageId);
        button.setAttribute('aria-pressed', String(selected));
        if (selected) { this.querySelector('[data-photo-count]').textContent = `${button.dataset.photo} / ${this.querySelectorAll('[data-photo]').length}`; button.parentElement.scrollLeft = button.offsetLeft - button.parentElement.offsetLeft - 20; }
      });
    }
    syncQuantity() {
      this.quantity.value = Math.min(10,Math.max(1,Math.floor(Number(this.quantity.value)||1)));
      this.querySelector('[data-quantity="-1"]').disabled = Number(this.quantity.value) <= 1;
      this.querySelector('[data-quantity="1"]').disabled = Number(this.quantity.value) >= 10;
      this.querySelector('[data-preview-quantity]').textContent = this.quantity.value;
    }
    openDialog(dialog, opener) { this.opener=opener; dialog.showModal(); }
    async add(event) {
      event.preventDefault();
      this.syncQuantity();
      if (this.preview) { this.openDialog(this.querySelector('[data-preview-dialog]'), event.submitter); return; }
      if (!this.variant.available || this.busy) return;
      this.busy = true;
      const error = this.querySelector('[data-error]'); error.hidden = true;
      this.querySelectorAll('[data-add]').forEach(button => { button.disabled=true; button.setAttribute('aria-busy','true'); });
      this.querySelector('[data-cta-text]').textContent = this.data.adding;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:Number(this.quantity.value)}]})});
        const result=await response.json();
        if (!response.ok) throw new Error(result.description || this.data.error);
        location.assign(this.dataset.cartUrl);
      } catch (exception) {
        error.textContent=exception.message || this.data.error; error.hidden=false;
        this.select(this.variant.id,false);
      } finally {
        this.busy=false;
        this.querySelectorAll('[data-add]').forEach(button => button.removeAttribute('aria-busy'));
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
